import { render, staticRenderFns } from "./SlidingBayDescription.vue?vue&type=template&id=57b26272&scoped=true"
import script from "./SlidingBayDescription.vue?vue&type=script&lang=ts"
export * from "./SlidingBayDescription.vue?vue&type=script&lang=ts"
import style0 from "./SlidingBayDescription.vue?vue&type=style&index=0&id=57b26272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b26272",
  null
  
)

export default component.exports